import React from 'react'
import styled from '@emotion/styled'
import Typography from '../../../components/Typography'
import MaterialSymbol from '../../../components/MaterialSymbol'
import TestIds from '../../../testIds'
import TextField from '../../../components/TextField'
import { Box, FormControlLabel, IconButton, Radio, RadioGroup } from '@mui/material'
import { colors } from '../../../themes/colors'
import { createSearchParams, useNavigate } from 'react-router-dom'
import { SortingOptions } from '../../../util/consts'
import Analytics from '../../../services/analytics'

const Container = styled('form')`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;

  background: linear-gradient(90deg, #004733 -1.7%, #00553d 33.83%, #6f8a5a 145.38%);
`

const SearchBar = () => {
  const [searchText, setSearchText] = React.useState<string>('')
  const [selected, setSelected] = React.useState('0')
  const navigate = useNavigate()
  const search = () => {
    if (searchText) {
      Analytics.push({
        dataLayer: {
          event: 'search_term',
          searchTerm: searchText,
        },
      })
    }

    navigate({
      pathname: '/products',
      search: createSearchParams({
        s: searchText ?? '',
        tab: selected,
        st: selected === '0' ? SortingOptions.MostRecent : SortingOptions.BestMatch,
      }).toString(),
    })
  }
  return (
    <Container onSubmitCapture={search}>
      <Typography variant='h4' component='p' color={'shade0'}>
        I&rsquo;m looking for...
      </Typography>

      <Box width='100%'>
        <TextField
          sx={{ height: '45px', pr: '3px' }}
          variant={'outlined'}
          placeholder='Search Farmlands products'
          value={searchText}
          testId={TestIds.components.searchWidget.searchBar}
          onSubmitCapture={search}
          inputProps={{ maxLength: 200 }}
          InputProps={{
            endAdornment: (
              <IconButton
                onClick={search}
                color='primary'
                title='Search'
                data-testid={TestIds.components.searchWidget.searchIcon}
              >
                <MaterialSymbol>search</MaterialSymbol>
              </IconButton>
            ),
          }}
          onChange={(event) => setSearchText(event.target.value)}
        />
      </Box>

      <Box display='flex' width='100%' justifyContent={'space-between'}>
        <RadioGroup
          aria-labelledby='demo-radio-buttons-group-label'
          defaultValue={selected}
          name='search-radio-buttons-group'
          color='tertiary'
          sx={{ display: 'flex', flexDirection: 'row', color: 'white' }}
          onSubmitCapture={search}
          onChange={(value) => setSelected(value.currentTarget.value)}
          data-testid={TestIds.components.searchWidget.radioButtonGroup}
        >
          <FormControlLabel
            slotProps={{
              typography: {
                color: colors.shade0,
              },
            }}
            control={<Radio color='tertiary' />}
            value='0'
            label='Previously ordered'
            data-id={TestIds.components.searchWidget.radioButtonGroupDataId('previously-ordered')}
          />
          <FormControlLabel
            slotProps={{
              typography: {
                color: colors.shade0,
              },
            }}
            control={<Radio color='tertiary' />}
            value='1'
            label='All'
            data-id={TestIds.components.searchWidget.radioButtonGroupDataId('all')}
          />
        </RadioGroup>
      </Box>
    </Container>
  )
}

export default SearchBar
